'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  flex-shrink: 0;\n  padding-top: 15px;\n  margin-bottom: 16px;\n'], ['\n  flex-shrink: 0;\n  padding-top: 15px;\n  margin-bottom: 16px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  opacity: 0;\n  left: -6px;\n\n  ', ';\n'], ['\n  position: absolute;\n  opacity: 0;\n  left: -6px;\n\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  width: 280px;\n  display: flex;\n  flex-flow: column nowrap;\n  padding: 0 22px;\n\n  @media (max-width: 960px) {\n    width: 250px;\n    font-size: 15px;\n  }\n'], ['\n  height: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  width: 280px;\n  display: flex;\n  flex-flow: column nowrap;\n  padding: 0 22px;\n\n  @media (max-width: 960px) {\n    width: 250px;\n    font-size: 15px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 26px;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: 5px;\n'], ['\n  font-size: 26px;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: 5px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow-y: auto;\n  padding-bottom: 20px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n'], ['\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow-y: auto;\n  padding-bottom: 20px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-bottom: 5px;\n  cursor: pointer;\n  color: #666;\n  padding: 5px 0;\n  position: relative;\n\n  &:hover {\n    color: #222;\n  }\n\n  ', ' ', ';\n'], ['\n  margin-bottom: 5px;\n  cursor: pointer;\n  color: #666;\n  padding: 5px 0;\n  position: relative;\n\n  &:hover {\n    color: #222;\n  }\n\n  ', ' ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require('../../assets/icons');

var _builtWith = require('../built-with');

var _builtWith2 = _interopRequireDefault(_builtWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var autoScroll = true;

var Toc = function (_React$Component) {
  _inherits(Toc, _React$Component);

  function Toc() {
    _classCallCheck(this, Toc);

    return _possibleConstructorReturn(this, (Toc.__proto__ || Object.getPrototypeOf(Toc)).apply(this, arguments));
  }

  _createClass(Toc, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var currentSlide = this.props.currentSlide;

      if (prevProps.currentSlide !== currentSlide) {
        this.scrollToItem(currentSlide);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToItem(this.props.currentSlide);
    }
  }, {
    key: 'scrollToItem',
    value: function scrollToItem(index) {
      var _toc = this._tocEl;

      if (!autoScroll || !_toc) {
        return;
      }

      var item = _toc.querySelector('[data-index="' + index + '"]');
      if (item && item.scrollIntoView) {
        item.scrollIntoView({ block: 'center' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          slides = _props.slides,
          currentSlide = _props.currentSlide,
          switchSlide = _props.switchSlide;


      return _react2.default.createElement(
        NavigationBody,
        { className: className },
        _react2.default.createElement(
          Header,
          null,
          _react2.default.createElement(
            PresentationName,
            null,
            this.props.presentationName
          ),
          _react2.default.createElement(_builtWith2.default, null)
        ),
        _react2.default.createElement(
          TableOfContents,
          { innerRef: function innerRef(el) {
              return _this2._tocEl = el;
            } },
          slides.map(function (slide, index) {
            return _react2.default.createElement(
              SlideItem,
              {
                key: index,
                current: index === currentSlide,
                future: index > currentSlide,
                onClick: function onClick() {
                  return switchSlide(index);
                },
                'data-index': index
              },
              _react2.default.createElement(SlideArrow, { isVisible: index === currentSlide }),
              ' ',
              slide.name || 'Slide #' + (index + 1)
            );
          })
        )
      );
    }
  }]);

  return Toc;
}(_react2.default.Component);

var Header = _styledComponents2.default.div(_templateObject);

// filter out `isVisible` prop
var SlideArrow = (0, _styledComponents2.default)(function (_ref) {
  var isVisible = _ref.isVisible,
      rest = _objectWithoutProperties(_ref, ['isVisible']);

  return _react2.default.createElement(_icons.RightArrow, rest);
})(_templateObject2, function (props) {
  return props.isVisible && '\n    opacity: 1;\n  ';
});

var NavigationBody = _styledComponents2.default.div(_templateObject3);

var PresentationName = _styledComponents2.default.div(_templateObject4);

var TableOfContents = _styledComponents2.default.div(_templateObject5);

var SlideItem = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.current && '\n    color: black;\n    padding-left: 18px;\n  ';
}, function (props) {
  return props.future && '\n    opacity: 0.4;\n  ';
});

exports.default = Toc;